module.exports = __webpack_public_path__ + "static/10-57c8bbe4b3c21cb5e9e6b9761427c6ab.jpg";